import axios, { AxiosRequestConfig } from 'axios';
import { cookies } from '../hooks/useCookies';
import { toast } from 'react-toastify';

export const baseURL = process.env.REACT_APP_API_URL;

export const api = axios.create({
  baseURL,
});

// api.interceptors.response.use(
//   response => response,
//   async error => {
//     try {
//       const newToken = await getReCaptchaToken();
//       window.dispatchEvent(new CustomEvent('recaptcha:update', { detail: newToken }));
//     } catch (recaptchaError) {
//       toast.error("Não foi possível validar o recaptcha.");
//         cookies.remove('@Somos:user');
//         cookies.remove('@Somos:access');
//         cookies.remove('@Somos:refresh');
//         window.location.pathname = '/';
//         window.location.reload();
//     }

//     return Promise.reject(error);
//   }
// );

api.interceptors.request.use(
  (config) => {
    const token = cookies.get('@Somos:access');
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export async function refreshToken() {
  interface Response {
    access: string;
    refresh: string;
  }

  return new Promise(async (resolve) => {
    await api
      .post('/user/token/refresh/', { refresh: cookies.get('@Somos:refresh') })
      .then((response) => {
        const responseData = response.data as Response;
        cookies.set('@Somos:refresh', responseData.refresh, {
          path: '/',
          sameSite: 'lax',
        });
        cookies.set('@Somos:access', responseData.access, {
          path: '/',
          sameSite: 'lax',
        });
        requestDefaults.headers.Authorization = `Bearer ${responseData.access}`;
        resolve(true);
      })
      .catch((error) => {
        if (error.response?.data?.detail) {
          toast.error(error.response.data.detail);
        }
        cookies.remove('@Somos:user');
        cookies.remove('@Somos:access');
        cookies.remove('@Somos:refresh');
        resolve(false);
        window.location.pathname = '/';
        window.location.reload();
      });
  });
}

export function get( path: string, data?: object, options?: { content_type?: string, recaptcha_token?: string }) {
  let headers = {
    Authorization: requestDefaults.headers.Authorization,
    'Content-Type': requestDefaults.headers['Content-Type'],
    'recaptcha-token': requestDefaults.headers['recaptcha-token'],
  };

  if (options?.content_type) {
    headers['Content-Type'] = options.content_type;
  }
  if (options?.recaptcha_token) {
    headers['recaptcha-token'] = options.recaptcha_token;
  }

  const config: AxiosRequestConfig = {
    params: data,
    headers,
  };

  return new Promise(async (resolve) => {
    await api.get(path, config)
      .then(response => resolve(response))
      .catch(async (error) => {
        if (error.response.status === 401) {
          const refreshed = await refreshToken();
          if (refreshed) {
            await api.get(path, config)
              .then(response => resolve(response))
              .catch(err => resolve(err.response ?? err));
          } else {
            resolve(error.response ?? error);
          }
        } else {
          resolve(error.response ?? error);
        }
      });
  });
}

export function destroy(path: string) {
  return new Promise(async (resolve) => {
    await api
      .delete(path, requestDefaults)
      .then((response) => {
        resolve(response);
      })
      .catch(async (error) => {
        if (error.response.status === 401) {
          var res = await refreshToken();
          if (res) {
            await api
              .delete(path, requestDefaults)
              .then((response) => {
                resolve(response);
              })
              .catch((error) => {
                resolve(error.response);
              });
          }
        } else {
          resolve(error.response);
        }
      });
  });
}

export function put(path: string, data: object) {
  return new Promise(async (resolve) => {
    await api
      .put(path, data, requestDefaults)
      .then((response) => {
        resolve(response);
      })
      .catch(async (error) => {
        if (error.response.status === 401) {
          var res = await refreshToken();
          if (res) {
            await api
              .put(path, data, requestDefaults)
              .then((response) => {
                resolve(response);
              })
              .catch((error) => {
                resolve(error.response);
              });
          }
        } else {
          resolve(error.response);
        }
      });
  });
}

export function post(path: string, data: object, options?: { content_type?: string, recaptcha_token?: string }) {
  let _requestDefaults = {
    headers: {
      Authorization: requestDefaults.headers.Authorization,
      'Content-Type': requestDefaults.headers['Content-Type'],
      'recaptcha-token': requestDefaults.headers['recaptcha-token'],
    },
  };

  if (options?.content_type) {
    _requestDefaults.headers['Content-Type'] = options.content_type;
  }
  if (options?.recaptcha_token) {
    _requestDefaults.headers['recaptcha-token'] = options.recaptcha_token;
  }

  return new Promise(async (resolve) => {
    await api
      .post(path, data, _requestDefaults)
      .then((response) => {
        resolve(response);
      })
      .catch(async (error) => {
        if (
          error.response.status === 401 &&
          error.response.data.detail !== 'Usuário e/ou senha incorreto(s)'
        ) {
          var res = await refreshToken();
          if (res) {
            await api
              .put(path, data, requestDefaults)
              .then((response) => {
                resolve(response);
              })
              .catch((error) => {
                resolve(error.response);
              });
          }
        } else {
          resolve(error.response);
        }
      });
  });
}

export const requestDefaults = {
  headers: {
    Authorization: '',
    'recaptcha-token': '',
    'Content-Type': 'application/json',
  },
};